import { MessageBar, MessageBarType } from "@fluentui/react";
import { useEffect, useState } from "react";

export interface IRegisterErrorBarProps {
    visible: boolean;
    type: MessageBarType;
    message: string;
}

export const RegisterMessageBar: React.FC<IRegisterErrorBarProps> = (props) => {
    const [visible, setVisible] = useState<boolean>(props.visible);

    useEffect(() => {
        setVisible(props.visible);
    }, [props.visible]);

    return (
        <>
            {
                visible ?
                    <MessageBar
                        messageBarType={props.type}
                        dismissButtonAriaLabel="Close"
                        onDismiss={() => setVisible(false)}
                    >
                        {props.message}
                    </MessageBar>
                : 
                    <></>
            }
        </>
    );
};